import client from './client';

export const listCuratedProducts = (params) => client.get('/curated-products', { params });

export const createCuratedProduct = (data) => client.post('/curated-products', data);

export const updateCuratedProduct = (productId, data) => client.put(`/curated-products/${productId}`, data);

export const publishCuratedProduct = (productId) => client.patch(`/curated-products/${productId}/publish`);

export const unpublishCuratedProduct = (productId) => client.patch(`/curated-products/${productId}/unpublish`);

export const deleteCuratedProduct = (productId) => client.delete(`/curated-products/${productId}`);
